import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from 'app/services/app/app.service';
import { LanguageService } from 'app/services/language/language.service';
import { RestService } from 'app/services/rest/rest.service';
import { EventsService } from '../../../services/events/events.service';
import { Utils } from 'app/components/utils/Utils';
import { ParameterCart } from 'app/models/cart-model';
import { ItemCart } from '../../../models/cart-model';
import moment from 'moment-timezone';
import { LoaderService } from 'app/services/loader/Loader.service';
import { ResumenPayment } from 'app/models/resumen-payment-model';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Log } from 'app/core/logging/log';
import { ItemInfoCart } from 'app/models/info-cart-model';
import { Logger } from 'app/core/logging/logger.service';


@Component({
    selector: 'app-locker-visor',
    templateUrl: './locker-visor.page.html',
    styleUrls: ['./locker-visor.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LockerVisorPage implements OnInit {

  orderUuid: string = '';
  paymentUuid:string = '';
  active: boolean = false;
  toPay: boolean = false;
  tracks: any;
  canceled: boolean = false;
  cancelable: boolean = false;
  subscription: boolean = false;
  closed: boolean = false;
  refresh: boolean = false;
  loading: number = 0;
  resumePayment: ResumenPayment = {
    startDate: null, 
    endDate: null,
    items: [], 
    total: 0, 
    tax: 0,
    kioskAddress: '',
    locationCode: '',
    userData: {
      email: ''
    },
    renovation: null,
    cancellationLimit: 0
  };

  t: boolean = true;
  waitingTime: string = null;


  constructor(
    private restService: RestService,
    public appService: AppService,
    private gtmService: GoogleTagManagerService,
    private router: Router,
    private language: LanguageService,
    private route: ActivatedRoute,
    private eventsService: EventsService,
    private loadingService: LoaderService
  ) { 
    this.orderUuid = this.route.snapshot.queryParamMap.get('code') || '';
  }

  ngOnInit() {
    this.appService.clearTenantId();
    this.appService.clearlocation();
    
    this.getResumenOnline();

    const gtmTag = {
      event: 'visor_resume',          // Nombre del evento en GTM
      conversion_value: 10,          // Precio de la venta
      conversion_currency: 'EUR',    // Opcional, útil para Google Ads / GA4
      payment_uuid: this.orderUuid
    };

    Log.debug("google tagmanager");
    this.gtmService.pushTag(gtmTag);
  }

  ngAfterViewInit(){
    this.eventsService.publish('refreshStep', { title: "Resumen", nameBt: null });
  }

  ngOnDestroy() {
    this.t = false;
  }

  getResumenOnline(){
    this.loadingService.setLoading(true);
    this.restService.getResumenOnline(this.orderUuid).subscribe((result:any) => { 
      if(result !=null){
        this.resumePayment = result;
      }
      
      this.appService.kiosk = this.resumePayment.locationCode;
      this.canceled = result.canceled;
      this.cancelable = result.cancelable;
      this.active = result.active;
      this.closed = result.closed;
      this.refresh = result.refresh;
      this.subscription = result.subscription;
      this.paymentUuid = result.paymentUuid;

      this.cancellationTimer();

      //if(this.allIsClosed){
       // alert('Todas las reservas cerradas');
       // this.router.navigate(['reserve/locker-type']);
      //}

      this.refreshMode();

    });
  }


  cancellationTimer() {
    if(this.subscription){
      return;
    }
    
    const cancellationDate = new Date(this.resumePayment.cancellationLimit);
    const now = new Date();
    
    // Calcular la diferencia en milisegundos
    const ms = cancellationDate.getTime() - now.getTime();
    
    if (ms <= 0) {
        // Si la fecha ya pasó o es justo ahora, se modifica de inmediato
        this.cancelable = false;
    } else {
        // Programar la ejecución en el momento exacto en el futuro
        setTimeout(() => {
            this.cancelable = false;
        }, ms);
        
        Log.debug(`Programado: La variable cambiará en ${(ms / 1000).toFixed(1)} segundos. Fecha de cancelación: ${cancellationDate}`);
    }
  }


  cancelCheckoutCard(){
    if(!confirm(this.appService.getTraduccion('reserve.confirmAction'))) {
      Log.trace("Implement delete functionality here");
      return;
    }

    if(this.subscription){
      this.restService.cancelSubscription(this.paymentUuid).subscribe((result:any) => { 
       setTimeout(()=> location.reload());
      }, 
      err => {
        setTimeout(()=> location.reload());
      });
    }else{
      this.restService.cancelCheckoutCard(this.paymentUuid).subscribe((result:any) => { 
        setTimeout(()=> location.reload());
      },
      error => {
        Log.error('Error cancel');
        setTimeout(()=> location.reload());
      });
    }
    
  }


  resendEmail(){
    this.restService.resendEmailUser(this.orderUuid).subscribe((result:any) => { 
      if(result == null){
        this.waitingTime = null;
        this.appService.showSuccessToast(this.appService.getTraduccion('common.actionSuccess'), 3000);
      }else{
        this.waitingTime = this.appService.getTraduccion('visor.resume.resend.waintingTime').replace("%s", result);

        let remainingSeconds = result;
        const intervalId: ReturnType<typeof setInterval> = setInterval(() => {
          remainingSeconds--;
          this.waitingTime = this.appService.getTraduccion('visor.resume.resend.waintingTime').replace("%s", String(remainingSeconds));

          if (remainingSeconds <= 0) {
            clearInterval(intervalId);
            this.waitingTime = null;
          }
        }, 1000);

      }
    });
  }
  


  refreshMode(){
    if(this.refresh){
        this.loading = 1;
        this.loadingService.setLoading(true);
        setTimeout(()=>{
          if(this.t){
            this.getResumenOnline();
          }
        }, 3000);
      }else{
        this.loading = 2;
        this.loadingService.setLoading(false);
      }
  }


  goToPay(itemInfoCart: ItemInfoCart){
    moment.locale("es");
    let startDate = this.resumePayment.renovation.startDate;
    let endDate = this.resumePayment.renovation.endDate;
    let now = moment(startDate);
    let future = moment(endDate);

    let itemCart:ItemCart = {
      reservationUuid: itemInfoCart.reservationUuid,
      categoryId: itemInfoCart.categoryId
    }
    let parameters:ParameterCart = {
      type: itemInfoCart.categoryId, //TODO deberia ser categoría padre
      items: [itemCart],
      startDate: this.formatDateTime(now),
      endDate: this.formatDateTime(future),
      userData: this.resumePayment.userData,
    }
    
    this.router.navigate([this.language.path('reserve'), this.appService.kiosk, 'checkout'], { queryParams: Utils.generateParams(parameters) });
  }

  formatDateTime(datetime: moment.Moment) {
    if (datetime == undefined) {
        return "";
    }
    return datetime.format('DD-MM-YYYY HH:mm')
  }

}
